function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
export default (({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.2114 6.55653H18.4118V3H5.5982V6.55653H4.7986C3.24938 6.55653 2 7.80132 2 9.32272V16.5445H5.5982V21H18.4018V16.5445H22V9.32272C22 7.80132 20.7406 6.55653 19.2014 6.55653H19.2114ZM7.5972 4.97585H16.4028V6.55653H7.5972V4.97585ZM16.4028 19.0241H7.5972V13.8771H16.4028V19.0241ZM20.001 14.5686H18.4018V11.9012H5.5982V14.5686H3.999V9.32272C3.999 8.88804 4.35882 8.53238 4.7986 8.53238H19.2114C19.6512 8.53238 20.011 8.88804 20.011 9.32272V14.5686H20.001ZM18.7716 10.1723C18.7716 10.5774 18.4318 10.9133 18.022 10.9133C17.6122 10.9133 17.2724 10.5774 17.2724 10.1723C17.2724 9.76729 17.6122 9.43139 18.022 9.43139C18.4318 9.43139 18.7716 9.76729 18.7716 10.1723Z",
  fill: fill || 'currentColor'
})));
//# sourceMappingURL=Print.js.map